import type { ReactNode } from "react";

import { Alert } from "../Alert";
import { Spinner } from "../Spinner";

export interface DataColumn<T> { id: string; header: string; cell: (row: T) => ReactNode }

interface DataTableProps<T> {
  caption: string;
  columns: readonly DataColumn<T>[];
  rows: readonly T[];
  rowKey: (row: T) => string;
  loading?: boolean;
  error?: string | undefined;
  emptyMessage?: string | undefined;
}

export function DataTable<T>({ caption, columns, rows, rowKey, loading = false, error, emptyMessage = "沒有資料" }: DataTableProps<T>) {
  if (loading) return <div aria-live="polite"><Spinner label={`${caption}載入中`} /></div>;
  if (error) return <Alert variant="danger">{error}</Alert>;
  return <div className="table-responsive"><table className="table table-bordered"><caption>{caption}</caption><thead><tr>{columns.map((column) => <th key={column.id} scope="col">{column.header}</th>)}</tr></thead><tbody>{rows.length === 0 ? <tr><td colSpan={columns.length}>{emptyMessage}</td></tr> : rows.map((row) => <tr key={rowKey(row)}>{columns.map((column) => <td key={column.id}>{column.cell(row)}</td>)}</tr>)}</tbody></table></div>;
}
